/* eslint-disable jsx-a11y/aria-proptypes */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { OverlayTrigger, Tooltip, Row, Col, Button } from "react-bootstrap";
import SVG from "react-inlinesvg";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  toAbsoluteUrl,
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelected,
  updatePrint,
  fetchAll,
  fetchMultiplePrint,
  createApproval,
} from "./deliverySlice";
import { useHistory } from "react-router-dom";
import {
  formatDate,
  sizePerPageList,
  showDialog,
  showConfirmDialog,
  StatusFormatter,
  attachFormatter,
  showErrorDialog,
  useForceUpdate,
  isAfterOrEqual,
  fareyeFormatter,
  formatDateTimeUtc,
} from "../../utility";

import LoadingFetchData from "../../utility/LoadingFetchData";
import { selectUser } from "../../modules/Auth/_redux/authRedux";

export const DeliveryTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
  params,
  handleSearch,
  cutoff,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(selectUser);

  const [tableData, setTableData] = useState(data);
  const [selectedRows, setSelectedRows] = useState([]);
  const [overlay, setOverlay] = useState(false);
  const forceUpdate = useForceUpdate();

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const showDetail = (column) => {
    dispatch(setSelected(column));
    history.push("/chief-delivery/delivery-detail");
  };

  // const printDetail = (column) => {
  //   dispatch(setSelected(column));
  //   history.push("/chief-delivery/print");
  // };
  const printFormatter = (cell, column, row) => {
    const url = `${process.env.REACT_APP_API_URL}/return/${column.retNumber}/form`;

    let icon;
    if (column.printStatus === "Y") {
      icon = (
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Reprint</Tooltip>}
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
            onClick={async () => {
              const action = await showConfirmDialog(
                "Are you sure want to Reprint this"
              );
              if (action.isConfirmed) {
                dispatch(updatePrint(column.retNumber));
                dispatch(fetchAll(params));
                window.open(url, "_blank").focus();
              }
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Files/File-done.svg")}
              />
            </span>
          </a>
        </OverlayTrigger>
      );
    } else if (column.printStatus === "N" && column.fpreStatus === "R") {
      icon = (
        <OverlayTrigger
          overlay={
            <Tooltip id="products-edit-tooltip">Reprint reupload</Tooltip>
          }
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
            onClick={async () => {
              const action = await showConfirmDialog(
                "Are you sure want to Reprint for Reupload this"
              );
              if (action.isConfirmed) {
                dispatch(updatePrint(column.retNumber));
                dispatch(fetchAll(params));
                window.open(url, "_blank").focus();
              }
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Code/Done-circle.svg")}
              />
            </span>
          </a>
        </OverlayTrigger>
      );
    } else if (column.printStatus === "Y" && column.fpreStatus === "R") {
      icon = (
        <OverlayTrigger
          overlay={
            <Tooltip id="products-edit-tooltip">Reprint reupload</Tooltip>
          }
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
            onClick={async () => {
              const action = await showConfirmDialog(
                "Are you sure want to Reprint for Reupload this"
              );
              if (action.isConfirmed) {
                dispatch(updatePrint(column.retNumber));
                dispatch(fetchAll(params));
                window.open(url, "_blank").focus();
              }
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Code/Done-circle.svg")}
              />
            </span>
          </a>
        </OverlayTrigger>
      );
    } else if (column.printStatus === "N") {
      icon = (
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Not Printed</Tooltip>}
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
            onClick={async () => {
              const action = await showConfirmDialog(
                "Are you sure want to Print this"
              );
              if (action.isConfirmed) {
                dispatch(updatePrint(column.retNumber));
                dispatch(fetchAll(params));
                window.open(url, "_blank").focus();
              }
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Devices/Printer.svg")}
              />
            </span>
          </a>
        </OverlayTrigger>
      );
    }
    return <span>{icon}</span>;
  };

  const uploadFormatter = (cell, column, row) => {
    let icon;

    // Cari cutoff berdasarkan PlantCode
    const plantCutoff = cutoff.find(
      (plant) => plant.plantCode === column.plantCode
    );

    // Ambil cutOffDate (kalau ada)
    const cutoffDate = plantCutoff?.cutOffDate || "";

    if (
      column.fareyeStatus === "Irrelevant - Cut Off" ||
      column.fareyeStatus === "Irrelevant - Plant"
    ) {
      icon = (
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Upload FPRE</Tooltip>}
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
            onClick={() => showDetail(column)}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Files/Upload.svg")} />
            </span>
          </a>
        </OverlayTrigger>
      );
    } else if (
      (column.fareyeStatus === "" && user.userName === "admin") ||
      (column.fareyeStatus === "Waiting" && user.userName === "admin")
    ) {
      icon = (
        <OverlayTrigger
          overlay={
            <Tooltip id="products-edit-tooltip">
              Waiting Status Fareye(By pass)
            </Tooltip>
          }
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
            onClick={() => showDetail(column)}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Warning-2.svg")} />
            </span>
          </a>
        </OverlayTrigger>
      );
    } else if (
      column.fareyeStatus === "Error" ||
      column.fareyeStatus === "Waiting"
    ) {
      // Upload langsung
      icon = (
        <OverlayTrigger
          overlay={
            <Tooltip id="products-edit-tooltip">Waiting Status Fareye</Tooltip>
          }
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
            onClick={() => showDialog("Waiting Status Fareye!")}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Warning-2.svg")} />
            </span>
          </a>
        </OverlayTrigger>
      );
    } else if (column.printStatus === "Y" && column.fareyeStatus !== "") {
      // Upload langsung
      icon = (
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Upload FPRE</Tooltip>}
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
            onClick={() => showDetail(column)}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Files/Upload.svg")} />
            </span>
          </a>
        </OverlayTrigger>
      );
    } else if (column.printStatus === "N" && column.fpreStatus === "R") {
      // Reupload
      icon = (
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Reupload</Tooltip>}
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
            onClick={() => showDetail(column)}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Code/Done-circle.svg")}
              />
            </span>
          </a>
        </OverlayTrigger>
      );
    } else if (column.printStatus === "N") {
      // Belum print
      icon = (
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">Not Printed</Tooltip>}
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
            onClick={() => showDialog("please print FPRE first!")}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Warning-2.svg")} />
            </span>
          </a>
        </OverlayTrigger>
      );
    } else {
      // Kalau cutoffDate kosong → anggap lewat cutoff
      if (!cutoffDate) {
        icon = (
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Upload FPRE</Tooltip>}
          >
            <a
              className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
              onClick={() => showDetail(column)}
            >
              <span className="svg-icon svg-icon-md svg-icon-primary">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Files/Upload.svg")} />
              </span>
            </a>
          </OverlayTrigger>
        );
      } else if (isAfterOrEqual(column.firstPrintDate, cutoffDate)) {
        if (!column.fareyeStatus) {
          icon = (
            <OverlayTrigger
              overlay={
                <Tooltip id="products-edit-tooltip">
                  Waiting Status Fareye
                </Tooltip>
              }
            >
              <a
                className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                onClick={() => showDialog("Waiting Status Fareye!")}
              >
                <span className="svg-icon svg-icon-md svg-icon-primary">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Code/Warning-2.svg")}
                  />
                </span>
              </a>
            </OverlayTrigger>
          );
        } else {
          icon = (
            <OverlayTrigger
              overlay={
                <Tooltip id="products-edit-tooltip">Upload FPRE</Tooltip>
              }
            >
              <a
                className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                onClick={() => showDetail(column)}
              >
                <span className="svg-icon svg-icon-md svg-icon-primary">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Files/Upload.svg")}
                  />
                </span>
              </a>
            </OverlayTrigger>
          );
        }
      } else {
        // kalau < cutoff
        icon = (
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Upload FPRE</Tooltip>}
          >
            <a
              className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
              onClick={() => showDetail(column)}
            >
              <span className="svg-icon svg-icon-md svg-icon-primary">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Files/Upload.svg")} />
              </span>
            </a>
          </OverlayTrigger>
        );
      }
    }

    return <span>{icon}</span>;
  };

  const labelPrintFormatter = (cell, column, row) => {
    let label;
    if (cell === "Y" && column.fpreStatus === "A") {
      label = (
        <span className={`label label-lg label-light-success label-inline`}>
          Printed
        </span>
      );
    } else if (cell === "Y" && column.fpreStatus === "W") {
      label = (
        <span className={`label label-lg label-light-success label-inline`}>
          Printed
        </span>
      );
    } else if (cell === "N" && column.fpreStatus === "W") {
      label = (
        <span
          className={`label label-lg label-light-danger label-inline label-width-status`}
        >
          Not Printed
        </span>
      );
    } else if (cell === "N" && column.fpreStatus === "R") {
      label = (
        <span className={`label label-lg label-light-info label-inline`}>
          Reupload
        </span>
      );
    } else if (cell === "Y" && column.fpreStatus === "R") {
      label = (
        <span className={`label label-lg label-light-info label-inline`}>
          Reupload
        </span>
      );
    }
    return <span>{label}</span>;
  };

  // Asumsikan data cut off array ada di variabel cutoffData
  // Contoh: const cutoffData = [...]; // dari data kamu

  const fareyeFormatter = (cellContent, row) => {
    let label = "";

    // Cari data plant berdasarkan PlantCode
    const plantCutoff = cutoff.find(
      (plant) => plant.plantCode === row.plantCode
    );

    // Ambil cutOffDate (kalau ada)
    const cutoffDate = plantCutoff?.cutOffDate || "";

    if (row.fareyeStatus !== "") {
      label = row.fareyeStatus;
    } else if (
      row.fareyeStatus === "" &&
      row.firstPrintDate === "0001-01-01T00:00:00Z"
    ) {
      label = "Not Send";

      // CASE 2: Belum ada status + ada error umum
    } else if (row.fareyeStatus === "" && row.fareyeLastError !== "") {
      label = "Error";
    } else if (
      row.fareyeStatus === "" &&
      row.firstPrintDate !== "0001-01-01T00:00:00Z"
    ) {
      label = "Waiting";
    } else if (row.fareyeStatus !== "") {
      label = row.fareyeStatus;
    } else {
      label = cellContent;
    }

    // Cutoff override
    if (
      row.fareyeStatus === "" &&
      row.firstPrintDate !== "0001-01-01T00:00:00Z" &&
      row.fareyeLastError === ""
    ) {
      if (!cutoffDate) {
        // Kalau cutoffDate kosong
        label = "Irrelevant - Cut Off";
      } else {
        // Kalau cutoffDate ada
        label = isAfterOrEqual(row.firstPrintDate, cutoffDate)
          ? "Waiting"
          : "Irrelevant - Cut Off";
      }
    }

    // Style mapping
    let style = "success";
    if (label === "Not Send" || label === "Error") {
      style = "danger";
    } else if (label === "Waiting") {
      style = "warning";
    } else if (label === "Irrelevant - Cut Off") {
      style = "primary";
    } else if (label === "Irrelevant - Plant") {
      style = "primary";
    }

    return (
      <span
        className={`label label-lg label-light-${style} label-inline label-width-pending-status`}
      >
        {label}
      </span>
    );
  };

  const dateFormatter = (cell) => {
    return <span>{formatDate(cell)}</span>;
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "action",
      text: "Action",
      formatter: printFormatter,
      align: "center",
    },
    {
      text: "Upload",
      dataField: "upload",
      formatter: uploadFormatter,
      align: "center",
    },
    {
      text: "Status",
      dataField: "printStatus",
      sort: true,
      sortCaret,
      headerSortingClasses,
      formatter: labelPrintFormatter,
      align: "center",
    },
    {
      text: "fareye Status",
      dataField: "fareyeStatus",
      sort: true,
      sortCaret,
      headerSortingClasses,
      formatter: fareyeFormatter,
      align: "center",
      style: { minWidth: "180px" },
    },
    {
      text: "fpreStatus",
      dataField: "fpreStatus",
      hidden: true,
    },
    {
      text: "Fareye Date Time",
      dataField: "fareyeDate",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: formatDateTimeUtc,
      style: { minWidth: "180px" },
    },
    {
      text: "APL Return Number ",
      dataField: "retNumber",
      sort: true,
      sortCaret,
      headerSortingClasses,
      align: "center",
    },
    {
      text: "Invoice Ref Num",
      dataField: "invoiceNo",
      sort: true,
      sortCaret,
      headerSortingClasses,
      align: "center",
    },
    {
      text: "Reason",
      dataField: "reasonName",
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Cust Name",
      dataField: "customerName",
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Remarks Return",
      dataField: "remark",
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Created By",
      dataField: "userName",
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
  ];

  const detailColumns = [
    { text: "Material", dataField: "materialCode" },
    {
      text: "Material Desc",
      dataField: "materialName",
    },
    { text: "Rayon Type", dataField: "rayonType" },
    { text: "Batch", dataField: "batch" },
    { text: "Uom", dataField: "uom", align: "center" },
    {
      text: "Return Uom",
      dataField: "returnUom",
    },
    { text: "Qty", dataField: "qty", align: "center" },
    {
      text: "Nra",
      dataField: "nra",
      formatter: StatusFormatter,
      align: "center",
    },
    { text: "Client Code", dataField: "clientCode", align: "center" },
    { text: "Exp Date", dataField: "expiredDate", formatter: dateFormatter },
    {
      text: "Photo Product",
      dataField: "attachmentId",
      formatter: attachFormatter,
      align: "center",
    },
    { text: "FSS/ASM/BM", dataField: "salesmanName", align: "center" },
  ];

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList,
  };

  const onSelectRow = {
    mode: "checkbox",
    clickToSelect: true,

    onSelectAll: (isSelect) => {
      if (isSelect) {
        setSelectedRows(data);
      } else {
        setSelectedRows([]);
      }
    },
    onSelect: (row, isSelect, rowIndex) => {
      if (isSelect) {
        setSelectedRows([...selectedRows, row]);
      } else {
        const index = selectedRows.indexOf(row);
        if (index > -1) {
          selectedRows.splice(index, 1);
        }
      }
    },
  };

  const expandRow = {
    // onlyOneExpanding: true,
    showExpandColumn: true,
    expandByColumnOnly: true,
    renderer: (row) => (
      <BootstrapTable
        keyField="approvalDetailId"
        data={row.items}
        columns={detailColumns}
      />
    ),
  };

  const handlePrint = async () => {
    const data = selectedRows.map((item) => item.retNumber);
    const listData = data.toString();
    const _listData = listData.replaceAll(",", "|");
    setOverlay(true);

    try {
      let i = 0;
      for (i; i < data.length; i++) {
        forceUpdate();
        const response = await dispatch(updatePrint(data[i]));
        if (response.payload.status === 200) {
        } else {
          setOverlay(false);
          showErrorDialog(response.payload.message);
        }
      }
    } catch (error) {
      setOverlay(false);
      showErrorDialog("eror something wrong");
    }
    try {
      const response = await dispatch(fetchMultiplePrint(_listData));
      if (response.payload.status === 200) {
        const blob = new Blob([response.payload.data], {
          type: "application/pdf",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "FPRE.pdf";
        link.click();

        setOverlay(false);
        handleSearch();
      } else {
        setOverlay(false);
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      setOverlay(false);
      showErrorDialog(error.message);
    }
  };

  const retnumber = [];

  let uniqueArr = [...new Set(retnumber)];

  const res = uniqueArr.map((retNumber) => ({ retNumber }));

  return (
    <>
      <LoadingFetchData active={overlay} />

      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={false}
        keyField="approvalId"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        expandRow={expandRow}
        selectRow={onSelectRow}
        hover
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>

      {/* Footer */}
      <Row className="mt-4">
        <Col md={1} xs={6} className="mb-5 mr-2">
          <Button
            variant="primary"
            onClick={() => {
              if (selectedRows.length > 0) {
                handlePrint();
              } else {
                showDialog("Please select row first");
              }
            }}
          >
            Print
          </Button>
        </Col>
      </Row>
    </>
  );
};
